"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Arc1SquareOutlined = exports.Arc1SquareFilled = exports.Arc1CircleOutlined = exports.Arc1CircleFilled = void 0;
var react_1 = __importDefault(require("react"));
var createCompose1_1 = require("./factory/createCompose1");
var CircleFilled_1 = require("./CircleFilled");
var CircleOutlined_1 = require("./CircleOutlined");
var Square_1 = require("./Square");
var base_1 = require("./base");
exports.Arc1CircleFilled = createCompose1_1.createCompose1({
    MainIcon: CircleFilled_1.CircleFilled,
    childFn: function (_, _a) {
        var arc = _a.arc;
        return react_1.default.createElement(base_1.Arc1, __assign({}, arc));
    },
});
exports.Arc1CircleOutlined = createCompose1_1.createCompose1({
    childFn: function (_a, _b) {
        var color = _a.color;
        var arc = _b.arc;
        return react_1.default.createElement(base_1.Arc1, __assign({ stroke: color }, arc));
    },
    MainIcon: CircleOutlined_1.CircleOutlined,
});
exports.Arc1SquareFilled = createCompose1_1.createCompose1({
    MainIcon: Square_1.SquareFilled,
    childFn: function (_, _a) {
        var arc = _a.arc;
        return react_1.default.createElement(base_1.Arc1, __assign({}, arc));
    },
});
exports.Arc1SquareOutlined = createCompose1_1.createCompose1({
    MainIcon: Square_1.SquareOutlined,
    childFn: function (_a, _b) {
        var color = _a.color;
        var arc = _b.arc;
        return react_1.default.createElement(base_1.Arc1, __assign({ stroke: color }, arc));
    },
});
